/**
 * Contact Us — hover underline animation for email and phone/fax lines.
 *
 * Replicates the same left→right scaleX underline sweep used on blog listing
 * card titles. Uses getClientRects() to place one absolutely-positioned span
 * per line box, then animates scaleX(0→1) on mouseenter and reverses on
 * mouseleave.
 *
 * - contact-us__info-email: inline <a> wrapped in a position:relative span
 * - contact-us__info-line: flex <a> — position:relative is on the element itself
 */
document.addEventListener("DOMContentLoaded", function () {
  var LINE_DURATION = 0.32;
  var LINE_EASE = "cubic-bezier(0.22, 0.61, 0.36, 1)";
  var UNDERLINE_OFFSET = 3;

  // -------------------------------------------------------------------------
  // Helper: attach underline animation to an element.
  // lineClass — CSS class for injected underline spans.
  // container — position:relative containing block for the spans.
  // trigger   — element that fires mouseenter/mouseleave (may equal container).
  // -------------------------------------------------------------------------
  function attachUnderline(trigger, container, lineClass) {
    var lineSpans = [];

    function buildLines() {
      lineSpans.forEach(function (s) { s.remove(); });
      lineSpans = [];

      var rects = Array.from(trigger.getClientRects());
      var containerRect = container.getBoundingClientRect();

      rects.forEach(function (rect, i) {
        var span = document.createElement("span");
        span.className = lineClass;
        span.style.left = (rect.left - containerRect.left) + "px";
        span.style.top = (rect.bottom - containerRect.top - UNDERLINE_OFFSET) + "px";
        span.style.width = rect.width + "px";
        span.style.transition = "transform " + LINE_DURATION + "s " + LINE_EASE + " " + (i * LINE_DURATION) + "s";
        container.appendChild(span);
        lineSpans.push(span);
      });
    }

    buildLines();

    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildLines, 120);
    });

    trigger.addEventListener("mouseenter", function () {
      lineSpans.forEach(function (span, i) {
        span.style.transition = "transform " + LINE_DURATION + "s " + LINE_EASE + " " + (i * LINE_DURATION) + "s";
        span.style.transform = "scaleX(1)";
      });
    });

    trigger.addEventListener("mouseleave", function () {
      var total = lineSpans.length;
      lineSpans.forEach(function (span, i) {
        var reverseDelay = (total - 1 - i) * LINE_DURATION;
        span.style.transition = "transform " + LINE_DURATION + "s " + LINE_EASE + " " + reverseDelay + "s";
        span.style.transform = "scaleX(0)";
      });
    });
  }

  // -------------------------------------------------------------------------
  // Email links — wrap in a position:relative span, then attach animation
  // -------------------------------------------------------------------------
  document.querySelectorAll(".contact-us__info-email").forEach(function (el) {
    var wrap = document.createElement("span");
    wrap.className = "contact-us__info-email-wrap";
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);
    attachUnderline(el, wrap, "contact-us__info-email-line");
  });

  // -------------------------------------------------------------------------
  // Phone/fax call links — position:relative is on the element itself
  // -------------------------------------------------------------------------
  document.querySelectorAll("a.contact-us__info-line").forEach(function (el) {
    attachUnderline(el, el, "contact-us__info-line-underline");
  });
});

/**
 * Contact Us — Google Maps JS API initialisation.
 *
 * Called as the Maps API callback (window.initContactMap) once the
 * Maps JS API has loaded. Finds the map canvas div, reads lat/lng from
 * data attributes, and initialises a minimal map:
 *   - disableDefaultUI removes all controls (zoom, street view, map type,
 *     fullscreen, rotate/tilt, scale, keyboard shortcuts UI)
 *   - gestureHandling: 'cooperative' prevents scroll-jacking
 *   - A single marker is placed at the coordinates
 */
window.initContactMap = function () {
  var canvas = document.querySelector(".contact-us__map-canvas");
  if (!canvas) return;

  var lat = parseFloat(canvas.getAttribute("data-lat"));
  var lng = parseFloat(canvas.getAttribute("data-lng"));
  if (isNaN(lat) || isNaN(lng)) return;

  var map = new google.maps.Map(canvas, {
    center: { lat: lat, lng: lng },
    zoom: 15,
    disableDefaultUI: true,
    gestureHandling: "cooperative",
    keyboardShortcuts: false,
  });

  new google.maps.Marker({
    position: { lat: lat, lng: lng },
    map: map,
  });
};
